// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { mergeTransactionData } from "_core/slices/datas/TransactionSlice";


const AdminRagTrainStatusApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/rag_train_status";

    // RAGファイルの学習状態(待機中・学習中の進捗・失敗)を取得し、tAssetList に id で上書きマージする
    const ExecAdminRagTrainStatusApi = async () => {
        let response = null;
        let error = null;

        try {
            response = await ApiRequest({ url:url, requestParams:{} });
        } catch (e) {
            error = e;
        }

        if (response !== null && response.error_code === 0 && response['t_asset_list'] != null) {
            dispatch(mergeTransactionData({
                tAssetList:response['t_asset_list'],
            }));
        }
        return { response, error };
    };

    return ExecAdminRagTrainStatusApi;
};

export default AdminRagTrainStatusApi;
